<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/production/palletized/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-pallet-boxes"></i><span class="space-icon"></span>
      {{ $t("labels.package_groups_title") }}
    </h1>

    <div class="mt-4 flex flex-row justify-between">
      <div class="panel-plain-label">
        <badge-default
          :label="`${getFormatNumber(total_rows)} ${$t(
            'labels.total_package_groups'
          )}`"
        />
      </div>

      <button
        type="button"
        @click.prevent="goToNewPackageGroup"
        class="btn-white"
      >
        <i class="fa-solid fa-plus"></i>
        <span class="space-icon"></span>
        {{ $t("labels.new_package_group_button") }}
      </button>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="height: 600px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef()"
        :rowData="package_groups"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="Number(total_rows) > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/palletized/show_process.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import {
  dateFilter,
  booleanFilter,
} from "@/components/views/mixins/ag_grid_filters.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";
import YesNoLabel from "@/components/views/layout/ag_grid/YesNoLabel.vue";
export default {
  name: "PHProductionPalletizedShowProcessPackageGroups",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      current_page: 1,
      rows_per_page: 20,
      package_groups: [],
      total_rows: 0,
      columnDefs: [
        {
          headerName: this.$t("model.package_group.week"),
          field: "week",
          filter: true,
        },
        {
          headerName: this.$t("model.package_group.grouped_at"),
          valueGetter: (params) => {
            return params.data.grouped_at;
          },
          valueFormatter: (params) => {
            return this.dateFormatter(params.data.grouped_at);
          },
          filter: "agDateColumnFilter",
          filterParams: dateFilter,
        },
        {
          headerName: this.$t("model.package_group.total_packages"),
          field: "total_packages",
          filter: "agNumberColumnFilter",
        },
        {
          headerName: this.$t("model.package_group.comment"),
          field: "comment",
          flex: 2,
        },
        {
          headerName: this.$t("model.package_group.ready_to_container"),
          field: "ready_to_container",
          filter: "agNumberColumnFilter",
          filterParams: booleanFilter,
          cellRenderer: YesNoLabel,
        },
        {
          headerName: "",
          field: "id",
          filter: false,
          flex: 1,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: this.$t("labels.manage_link"),
                path_name: this.routeName("show_package_group"),
                params_path: {
                  packing_house_id: this.packing_house_id,
                  packing_house_process_id: this.packing_house_process_id,
                  id: params.value,
                },
              },
            };
          },
        },
      ],
    };
  },
  props: {
    packing_house_id: { required: true },
    packing_house_process_id: { required: true },
  },
  watch: {
    current_page: function () {
      this.fetchPackageGroups();
    },
  },
  created() {
    this.fetchPackageGroups();
  },
  methods: {
    fetchPackageGroups: async function () {
      const response = await Requester.fetchPackageGroups(
        this.packing_house_id,
        this.packing_house_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.total_rows = response.data.total_rows;
      this.package_groups = response.data.records;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },
    defaultColDef: function () {
      return {
        sortable: true,
        floatingFilter: true,
        filter: true,
      };
    },
    goToNewPackageGroup() {
      this.$router.push({
        name: this.routeName("new_package_group"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
        },
      });
    },
  },
};
</script>
